export default __webpack_public_path__ + "static/media/permeable-blog-13.046b0997.jpg";